module.exports = __webpack_public_path__ + "img/Forestbook_devices.d0a94a13.png";